import { type ComponentPropsWithoutRef, type ComponentRef, forwardRef } from 'react';
import { ContextMenuContent as RadixContextMenuContent } from '@radix-ui/react-context-menu';
import { cn } from '@/utils';
import { BaseDropdownContainerUI } from '../base/BaseDropdownContainerUI';
export const ContextMenuContent = forwardRef<ComponentRef<typeof RadixContextMenuContent>, Omit<ComponentPropsWithoutRef<typeof RadixContextMenuContent>, 'asChild'>>(({
  className,
  children,
  ...props
}, ref) => {
  return <RadixContextMenuContent {...props} asChild={true} ref={ref}>
      <BaseDropdownContainerUI className={cn('min-w-[150px] px-xs py-3xs flex flex-col', className)}>
        {children}
      </BaseDropdownContainerUI>
    </RadixContextMenuContent>;
});
ContextMenuContent.displayName = RadixContextMenuContent.displayName;